import { render, staticRenderFns } from "./ScopesCheckbox.vue?vue&type=template&id=73e455ca&"
import script from "./ScopesCheckbox.vue?vue&type=script&lang=js&"
export * from "./ScopesCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports